import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'

export const CompanyLoginRegisterFinish = () => {
  const bem = Util.bemFrom('company-login')

  return (
    <div className={bem('panel')}>
      <div className={bem('done')}>
        {Lang.msg.permission.regLinkRegistrationFinished}
      </div>
    </div>
  )
}
